module.exports = __webpack_public_path__ + "h5/img/promotion.640c3ecb.jpg";